import { useQuery } from '@tanstack/react-query';
import { useDataProvider } from 'react-admin';
import { useRegion } from '../auth/RegionContext';
import type { AdminDataProvider, DashboardStats } from '../dataProvider';

/**
 * Region-driven dashboard aggregates, read from the provider's `getDashboardStats`
 * seam (NOT computed in the component). Keyed on the active region, so flipping
 * the switcher re-fetches and updates every number. Uses the QueryClient that
 * `<Admin>` already provides.
 */
export const useDashboardStats = (): {
  stats: DashboardStats | null;
  isLoading: boolean;
} => {
  const dataProvider = useDataProvider<AdminDataProvider>();
  const { activeRegion } = useRegion();
  const { data, isLoading } = useQuery({
    queryKey: ['dashboardStats', activeRegion],
    queryFn: () =>
      dataProvider
        .getDashboardStats({ region: activeRegion })
        .then((r) => r.data),
  });
  return { stats: data ?? null, isLoading };
};
